import Image from 'next/image';

const PyramidsGray = () => (
  <Image
    src="/keepsimple_/assets/home-page/company-management.png"
    alt="UX Core Gray"
    width={70}
    height={70}
  />
);

export default PyramidsGray;
